/**
 * Where the team works (owner, 2026-10-04): the four cities on the Team
 * globe and in its HTML list. City names only on the map, as the owner chose.
 * Bangkok is home, so the main links run from it; the others are linked to
 * each other too, as one team.
 */
export interface City {
  id: string;
  city: string;
  /** Shown in the HTML list after the city; null where the city says it all. */
  country: string | null;
  lat: number;
  lon: number;
  home?: boolean;
  /** Which side of its pin the label sits on the globe, so the close pair
   *  (Bangkok and Hong Kong) never crowd each other. Default: above. */
  side?: 'top' | 'left' | 'right';
}

export const CITIES: readonly City[] = [
  { id: 'bkk', city: 'Bangkok', country: 'Thailand', lat: 13.7563, lon: 100.5018, home: true, side: 'left' },
  { id: 'hkg', city: 'Hong Kong', country: null, lat: 22.3193, lon: 114.1694, side: 'right' },
  { id: 'pek', city: 'Beijing', country: 'China', lat: 39.9042, lon: 116.4074 },
  { id: 'tyo', city: 'Tokyo', country: 'Japan', lat: 35.6762, lon: 139.6503 },
];

/** Drawn in this order as the section scrolls in: home first, then the rest. */
export const LINKS: readonly (readonly [string, string])[] = [
  ['bkk', 'hkg'],
  ['bkk', 'pek'],
  ['bkk', 'tyo'],
  ['hkg', 'pek'],
  ['pek', 'tyo'],
  ['hkg', 'tyo'],
];
